import type { ChanelActionType, BestBidOfferRepoWs } from "@trading/infrastructure";
import type { BestBidOfferModel } from "../models/best-bid-and-offer.model";

export default class BestBidOfferService {
  constructor(private repo: BestBidOfferRepoWs) {
  }

  /**
   * Ставит обработчик потока тиков bbo. Один на все инструменты — состав
   * подписки меняется через subscribeToSymbols/unsubscribeFromSymbols.
   * Возвращает функцию снятия обработчика.
   */
  async onBestBidOfferUpdate(
    cb: (data: BestBidOfferModel) => void,
    actionName?: ChanelActionType
  ): Promise<undefined | (() => void)> {
    if (actionName) {
      return await this.repo?.addUpdateHandler(actionName, cb)
    }

    const removeHandlers = await Promise.all([
      this.repo?.addUpdateHandler('update', cb),
      this.repo?.addUpdateHandler('snapshot', cb)
    ])

    return () => {
      removeHandlers.forEach((removeHandler) => removeHandler?.())
    }
  }

  async subscribeToSymbols(instruments: string[]): Promise<void> {
    await this.repo?.subscribeToSymbols(instruments)
  }

  async unsubscribeFromSymbols(instruments: string[]): Promise<void> {
    await this.repo?.unsubscribeFromSymbols(instruments)
  }
}
